import React from 'react'
import { Checkbox, GraniteDataGrid } from '@tecuity/granite-ui'

const RecordUserAccessConfiguredMiscellaneousModules = (props) => {
  const { property = {}, editItem = {}, onChange, optionsMap } = props
  const {
    MiscAppliesToIds = [],
    MiscPasskeyDefaultIds = [],
    MiscRequestAccessDefaultIds = [],
    MiscLoggedInDefaultIds = [],
    MiscNotLoggedInDefaultIds = [],
  } = editItem

  const filterArray = (array, value) => {
    return array.includes(value) ? array.filter((v) => v !== value) : [...array, value]
  }

  const changeCheck = (id, type) => {
    onChange({
      ...editItem,
      MiscAppliesToIds: !MiscAppliesToIds.includes(id) ? [...MiscAppliesToIds, id] : MiscAppliesToIds,
      [type]: filterArray(editItem[type] || [], id),
    })
  }
  const changeAppliesTo = (id) => {
    if (MiscAppliesToIds.includes(id)) {
      // remove MiscellaneousModuleId from all lists.
      onChange({
        ...editItem,
        MiscAppliesToIds: MiscAppliesToIds.filter((v) => v !== id),
        MiscPasskeyDefaultIds: MiscPasskeyDefaultIds.filter((v) => v !== id),
        MiscRequestAccessDefaultIds: MiscRequestAccessDefaultIds.filter((v) => v !== id),
        MiscLoggedInDefaultIds: MiscLoggedInDefaultIds.filter((v) => v !== id),
        MiscNotLoggedInDefaultIds: MiscNotLoggedInDefaultIds.filter((v) => v !== id),
      })
    } else {
      onChange({
        ...editItem,
        MiscAppliesToIds: [...MiscAppliesToIds, id],
      })
    }
  }

  const columns = [
    {
      field: 'label',
      headerName: 'Miscellaneous Module',
      disableColumnMenu: true,
      renderCell: (params) => <p style={{ fontWeight: 'bolder' }}>{params.row.label}</p>,
    },
    {
      field: 'AppliesTo',
      key: '0',
      headerName: 'Applies to Module',
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Checkbox
            title={`Applies to Module - ${params.row.label}`}
            ariaLabel={`Applies to Module - ${params.row.label}`}
            checked={MiscAppliesToIds.includes(params.row.Id)}
            onChange={() => changeAppliesTo(params.row.Id)}
          />
        )
      },
    },
    {
      field: 'UseAsPasskeyDefault',
      headerName: `Passkey Default`,
      key: '1',
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Checkbox
            title={`Use as Passkey Default - ${params.row.label}`}
            ariaLabel={`Use as Passkey Default - ${params.row.label}`}
            checked={MiscPasskeyDefaultIds.includes(params.row.Id)}
            onChange={() => changeCheck(params.row.Id, 'MiscPasskeyDefaultIds')}
          />
        )
      },
    },
    {
      field: 'UseAsRequestAccessDefault',
      key: '2',
      headerName: 'Request Access Default',
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Checkbox
            title={`Use as Request Access Default - ${params.row.label}`}
            ariaLabel={`Use as Request Access Default - ${params.row.label}`}
            checked={MiscRequestAccessDefaultIds.includes(params.row.Id)}
            onChange={() => changeCheck(params.row.Id, 'MiscRequestAccessDefaultIds')}
          />
        )
      },
    },
    {
      field: 'UseAsLoggedInDefault',
      headerName: `Logged In Default`,
      key: '1',
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Checkbox
            title={`Use as Logged In Default - ${params.row.label}`}
            ariaLabel={`Use as Logged In Default - ${params.row.label}`}
            checked={MiscLoggedInDefaultIds.includes(params.row.Id)}
            onChange={() => changeCheck(params.row.Id, 'MiscLoggedInDefaultIds')}
          />
        )
      },
    },
    {
      field: 'UseAsNotLoggedInDefault',
      key: '2',
      headerName: 'Logged Out Default',
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Checkbox
            title={`Use as Logged Out Default - ${params.row.label}`}
            ariaLabel={`Use as Logged Out Default - ${params.row.label}`}
            checked={MiscNotLoggedInDefaultIds.includes(params.row.Id)}
            onChange={() => changeCheck(params.row.Id, 'MiscNotLoggedInDefaultIds')}
          />
        )
      },
    },
  ]
  return (
    <div key={property.k} style={{ marginBottom: '40px' }}>
      <GraniteDataGrid
        rowsPerPageOptions={[10, 25, 50]}
        getRowId={(row) => row.Id}
        selectable={false}
        compressedView={true}
        columns={columns}
        rows={optionsMap['miscModuleOptions'] || []}
        pageSize={10}
      />
    </div>
  )
}

export default RecordUserAccessConfiguredMiscellaneousModules
